import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledStationDirectory,

  /* StyledStationName, */
  StyledStationTableCell,
  StyledStationTableCellCommunity,
  StyledStationTableCellConcession,
  StyledStationTableCellFrecuency,
  StyledStationTableCellTelephone,
  StyledIcon,
  IconButton
} from './style';

import { Eye, Arrow } from '../../../../../assets/images/index';

class RowStation extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = { active: false };
  }

  onClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  render() {
    const { dataRow, onClickDetail } = this.props;

    return (
      <StyledStationDirectory active={this.state.active}>
        <IconButton
          svg={Arrow}
          size="s"
          hover
          active={this.state.active}
          onClick={this.onClick}
        />
        <StyledStationTableCellConcession title={dataRow.concession}>
          {' '}
          {!dataRow.locality ? '--' : dataRow.locality}{' '}
        </StyledStationTableCellConcession>
        <StyledStationTableCellCommunity title={dataRow.autonomousCommunity}>
          {' '}
          {!dataRow.autonomousCommunity
            ? '--'
            : dataRow.autonomousCommunity}{' '}
        </StyledStationTableCellCommunity>
        <StyledStationTableCellFrecuency title={dataRow.frequency}>
          {!dataRow.frequency ? '--' : dataRow.frequency}
        </StyledStationTableCellFrecuency>
        <StyledStationTableCellTelephone title={dataRow.phoneNumber}>
          {' '}
          {!dataRow.phoneNumber ? '--' : dataRow.phoneNumber}{' '}
        </StyledStationTableCellTelephone>
        <StyledStationTableCell>
          <StyledIcon
            onClick={() => onClickDetail(dataRow)}
            svg={Eye}
            size="m"
            profilee="button"
            hover
          />
        </StyledStationTableCell>
      </StyledStationDirectory>
    );
  }
}

RowStation.propTypes = {
  dataRow: PropTypes.shape({
    community: PropTypes.string,
    concession: PropTypes.string,
    frecuency: PropTypes.string,
    phone: PropTypes.string
  })
};

export default RowStation;
